import { render, staticRenderFns } from "./AamsReceptionRegApproval.vue?vue&type=template&id=f16f90fc&scoped=true&"
import script from "./AamsReceptionRegApproval.vue?vue&type=script&lang=js&"
export * from "./AamsReceptionRegApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16f90fc",
  null
  
)

export default component.exports